// src/services/userService.js
import api from './api';

const userService = {
  getDashboard: async () => {
    const res = await api.get('/v1/users/dashboard');
    return res.data;
  }
};

export default userService;
